module.exports = __webpack_public_path__ + "img/4.cad23489.png";